<!-- src/components/new-tip/FiltersBar.vue -->
<template>
  <v-card flat outlined class="mb-4">
    <v-card-text class="py-3">
      <v-row dense align="center">
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            v-model="local.campaign_id"
            :items="campaigns"
            item-text="name"
            item-value="id"
            label="Campagne"
            dense hide-details clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            v-model="local.supervisor_id"
            :items="supervisors"
            item-text="name"
            item-value="id"
            label="Superviseur"
            dense hide-details clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-select
            v-model="local.status"
            :items="visitStatuses"
            label="Statut"
            dense hide-details clearable
          />
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-menu v-model="dateFromMenu" :close-on-content-click="false" max-width="290">
            <template #activator="{ on }">
              <v-text-field
                :value="local.date_from" label="Du" readonly dense hide-details clearable
                v-on="on" @click:clear="local.date_from = null"
              />
            </template>
            <v-date-picker v-model="local.date_from" no-title @input="dateFromMenu = false" />
          </v-menu>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-menu v-model="dateToMenu" :close-on-content-click="false" max-width="290">
            <template #activator="{ on }">
              <v-text-field
                :value="local.date_to" label="Au" readonly dense hide-details clearable
                v-on="on" @click:clear="local.date_to = null"
              />
            </template>
            <v-date-picker v-model="local.date_to" no-title @input="dateToMenu = false" />
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="mt-1" no-gutters>
        <v-spacer />
        <v-btn small text @click="reset">Réinitialiser</v-btn>
        <v-btn small color="primary" @click="apply" class="ml-2">
          <v-icon left small>mdi-filter</v-icon>
          Appliquer
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { VISIT_STATUSES } from '@/constants/newTip';

export default {
  name: 'NewTipFiltersBar',
  props: {
    value: { type: Object, default: () => ({}) },
    campaigns: { type: Array, default: () => [] },
    supervisors: { type: Array, default: () => [] },
  },
  data() {
    return {
      local: { ...this.emptyFilters(), ...this.value },
      dateFromMenu: false,
      dateToMenu: false,
      visitStatuses: VISIT_STATUSES.map(s => ({ value: s.value, text: s.label })),
    };
  },
  watch: {
    value: { deep: true, handler(v) { this.local = { ...this.emptyFilters(), ...v }; } },
  },
  methods: {
    emptyFilters() {
      return {
        campaign_id: null, supervisor_id: null, salepoint_id: null,
        status: null, date_from: null, date_to: null,
      };
    },
    apply() { this.$emit('input', { ...this.local }); this.$emit('apply', { ...this.local }); },
    reset() { this.local = this.emptyFilters(); this.apply(); },
  },
};
</script>
